import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          background: #ffffff;\n          box-shadow: ", ";\n          border-radius: ", ";\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  padding: 0px;\n\n  margin: 0px;\n\n  ", "\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 17px;\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  color: ", ";\n  display: block;\n  min-width: 80px;\n  text-align: center;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { createPortal } from 'react-dom';
import styled, { css } from 'styled-components';
import { useDynamicBodyEl, getElOffset } from '../../shared';
import { arrow } from '../../shared/css'; // Legacy theme

var legacyBg = '#f8f8f8';
var legacyBorder = '#ededed';
var legacyCss = css(_templateObject(), legacyBg, legacyBorder, function (p) {
  return p.theme.text;
}, arrow({
  bgColor: legacyBg,
  borderColor: legacyBorder,
  borderWidth: 1,
  size: 17
}));

var legacyPositioning = function legacyPositioning(left, top) {
  return "\n  left: ".concat(left + 10, "px;\n  top: ").concat(top + 16, "px;\n  min-width: 80px;\n");
}; // END legacy theme


var List = styled.ul.attrs(function (props) {
  return _objectSpread(_objectSpread({}, props), {}, {
    tabIndex: -1,
    role: 'listbox',
    'aria-labelledby': "".concat(props.name, "-label")
  });
})(_templateObject2(), function (_ref) {
  var theme = _ref.theme;
  return theme.name === 'legacy' ? legacyCss : css(_templateObject3(), function (p) {
    return p.theme.shadowSmallest;
  }, function (p) {
    return p.theme.spacing(0, 0, 0.5, 0.5);
  });
}, function (_ref2) {
  var anchorRef = _ref2.anchorRef,
      theme = _ref2.theme;

  if (anchorRef && anchorRef.current) {
    var el = anchorRef.current;

    var _getElOffset = getElOffset(el),
        _getElOffset2 = _slicedToArray(_getElOffset, 2),
        left = _getElOffset2[0],
        top = _getElOffset2[1];

    return theme.name === 'legacy' ? legacyPositioning(left, top + el.offsetHeight) : "\n          left: ".concat(left, "px;\n          top: ").concat(top + el.offsetHeight, "px;\n          width: ").concat(el.offsetWidth, "px;\n        ");
  }

  return 'width: 100%;';
});

var Dropdown = function Dropdown(_ref3) {
  var getItemProps = _ref3.getItemProps,
      listProps = _ref3.listProps,
      children = _ref3.children,
      anchorRef = _ref3.anchorRef,
      name = _ref3.name;
  var portalEl = useDynamicBodyEl();
  return createPortal( /*#__PURE__*/React.createElement(List, _extends({}, listProps, {
    anchorRef: anchorRef,
    name: name
  }), React.Children.map(children, function (ch, i) {
    return React.cloneElement(ch, getItemProps(i));
  })), portalEl);
};

export default Dropdown;